<template>
    <div>
      <Loading/>

      <div v-if='filtro'>
        <span><strong> {{listagem}} </strong></span>
        <form class="myForm mt-5" >
            <div hidden="true">
              <span class="badge badge-light p-3" id="dashboard"></span>
              <span class="badge badge-light p-3" id="dashboardFal"></span>
            </div>
            <div class="form-group row">
                <label for="nome" class="col-sm-2 col-form-label">Tipo Unidade</label>
                <div class="col-sm-2">
                  <multiselect v-model="filTipoUnida" tag-placeholder="Selecione" placeholder="Tipo Unid." label="" track-by="" select-label="" deselect-label="X" selectedLabel="" :options="tipoUnidade" @tag="addTag" @input="contaValores" @remove="contaValores"><span slot="noResult" class="text-info">Tipo não encontrada</span></multiselect>

                </div>
                <label for="nome" class="col-sm-2 col-form-label">Unidade</label>
                <div class="col-sm-2">
                  <multiselect v-model="filUnidades" tag-placeholder="Selecione" placeholder="Unidades" label="" track-by="" select-label="" deselect-label="X" selectedLabel="" :options="unidades" @tag="addTag" @input="contaValores" @remove="contaValores"><span slot="noResult" class="text-info">Unid. não encontrada</span></multiselect>
                </div>

                <label for="nome" class="col-sm-2 col-form-label">Fornecedor</label>
                <div class="col-sm-2">
                  <multiselect v-model="filFornecedores" tag-placeholder="Selecione" placeholder="Fornecedor" label="" track-by="" select-label="" deselect-label="X" selectedLabel="" :options="fornecedore" @tag="addTag" @input="contaValores" @remove="contaValores"><span slot="noResult" class="text-info">Forn. não encontrado</span></multiselect>
                </div>
            </div>

            <div class="form-group row">
                <label for="nome" class="col-sm-2 col-form-label">Tipo Fornecimento</label>
                <div class="col-sm-2">
                    <multiselect v-model="filTipoForn" tag-placeholder="Selecione" placeholder="Tipo Forn." label="" track-by="" select-label="" deselect-label="X" selectedLabel="" :options="filTipoForneci" @tag="addTag" @input="contaValores" @remove="contaValores"><span slot="noResult" class="text-info">Tipo não encontrado</span></multiselect>
                </div>
                <label for="nome" class="col-sm-2 col-form-label">Mês Ref.</label>
                <div class="col-sm-2">
                  <multiselect v-model="filMesRefer" tag-placeholder="Selecione" placeholder="Mes Ref." label="" track-by="" select-label="" deselect-label="X" selectedLabel="" :options="optionsMes" @tag="addTag" @input="contaValores" @remove="contaValores"><span slot="noResult" class="text-info">Mês não encontrado</span></multiselect>
                </div>

                <label for="nome" class="col-sm-2 col-form-label">Ano Ref.</label>
                <div class="col-sm-2">
                  <multiselect v-model="filAnoRefer" tag-placeholder="Selecione" placeholder="Ano Ref." label="" track-by="" select-label="" deselect-label="X" selectedLabel="" :options="optionsAno" @tag="addTag" @input="contaValores" @remove="contaValores"><span slot="noResult" class="text-info">Ano não encontrado</span></multiselect>

                </div>
            </div>

        </form>
      </div>
      <br/>
      <div class="col-12" style="background-color:#ced4da; text-align:center; padding-top:6px; padding-bottom:6px;">CONSUMO</div>
      <div>
        <div style="height:700px;">
          <div id="gridbox" style="min-width:100%; min-height:100%; background-color:white;"></div>
        </div>
        <div class="my-3" style="margin-left: 800px;">
          <div id='recArea' class="bg-secondary text-center text-white mb-2"></div>
          <div id='recstate' class="text-center text-primary"></div>
        </div>
      </div>
      <div class="container">
      </div>
      <div class="col-12" style="background-color:#ced4da; padding-top:6px; padding-bottom:6px;">Totais</div>
      <div class="row mt-2">
        <div class='col-6 tipoforne'>
            <ul v-for="(tipo, i) in qtFornecedores" :key="i">
              <li><b>{{tipo.tp01_descricao}} - {{tipo.ba03_consumo}} {{tipo.tp01_medicao}}</b></li>
            </ul>
        </div>
        <div class='col-6' :hidden="total">
            <span id="valor"></span>
        </div>
      </div>
    </div>

</template>

<script>
import Loading from '@/components/Loading'
import Multiselect from 'vue-multiselect'


export default {
  name: 'Relatorio',
  components: {
    Loading
  },
  props: {
    filtro: String
  },
  components: {
     Multiselect,
      Loading
  },
  data () {
      return {
        listagem: 'listagem',
        dados: '',
        paginaTop: '',
        mes: '',
        ano: '',
        listagem: 'RELATÓRIO',
        qtFornecedores: [],
        anosCombo: [],
        anos: [],
        unidades: [],
        total: false,
        gridCadastroContas: '',
        filTipoUnida: '',
        filUnidades: '',
        filFornecedores: '',
        filTipoForneci: [],
        filMesRefer: '',
        filAnoRefer: '',
        tipoUnidade: [],
        fornecedore: [],
        tipoForneciment: [],
        filTipoForn: '',
        filTipoForn: [],
        filMesRef: new Date().getMonth() + 1,
        optionsAno: [],
        filAnoRef: new Date().getFullYear(),
        optionsMes: [],
        optionsTipoFor: [],
        recarregaGrid: false
      }
  },
  methods: {

    dhtmlx(conta = null, filFor = '', filTpUni = '', filUni = '', filTpFo = '', filMesR = '', filAnoR = ''){
      let url = ''

      if(conta == null){
        url = '/api/contas-consumo/cadastro-contas/dhtmlx';

        api.enviarRequisicao('get', '/api/contas-consumo/cadastro-contas/fornecimento/general-count')
        .then(response => {
          this.qtFornecedores = response.data
        });
      }
      else{
        url = 'api/contas-consumo/cadastro-contas/dhtmlx';

        api.enviarRequisicao('get', '/api/contas-consumo/cadastro-contas/fornecimento/general-count')
        .then(response => {
          this.qtFornecedores = response.data;
        });
      }

      api.enviarRequisicao('get', url)
        .then(response => {
          this.dados = response.data;
          this.gridCadastroContas.parse(this.dados, "json");

          this.gridCadastroContas.filterBy(4, filFor)
          this.gridCadastroContas.filterBy(1, filTpUni, true)
          this.gridCadastroContas.filterBy(2, filUni, true)
          this.gridCadastroContas.filterBy(3, filTpFo, true)
          this.gridCadastroContas.filterBy(9, filMesR, true)
          this.gridCadastroContas.filterBy(10, filAnoR, true)

          this.$parent.renderizaTotal()

        });
      this.gridCadastroContas = new dhtmlXGridObject("gridbox");
      this.gridCadastroContas.setImagePath("libs/imgs/");
      this.gridCadastroContas.setHeader("Codigo,Tipo Unidade, Unidade, Tipo Fornecimento, Fornecedor, Contrato, Data de Venc., Consumo, Valor, Mes Ref, Ano Ref, Contrato Id");
      this.gridCadastroContas.setInitWidths("10,90,200,90,110,200,100,80,90,90,90,190");
      this.gridCadastroContas.setColAlign("center,left,left,left,left,left,left,left,left,left,left,left");
      this.gridCadastroContas._in_header_stat_total(document.getElementById('valor'),8,["<span><b>Valor Total: </b>R$ ","</span>"]);
      this.gridCadastroContas._in_header_stat_count(document.getElementById('dashboard'),1,[]);
      this.gridCadastroContas.setColTypes("ro,ro,ro,ro,ro,ro,ro,ro,edn,ro,ro,edn");
      this.gridCadastroContas.setColSorting("int,str,str,str,str,str,str,str,str,str,str,str");
      this.gridCadastroContas.setColumnHidden(0,true);
      this.gridCadastroContas.setColumnHidden(9,true);
      this.gridCadastroContas.setColumnHidden(10,true);
      this.gridCadastroContas.setColumnHidden(11,true);
      this.gridCadastroContas.setNumberFormat("0,000,000,000.00",8,",",".");
      this.gridCadastroContas.init();
      // this.gridCadastroContas.enableSmartRendering(true,50);
    },
  contaValores(){
      var forne = this.filFornecedores
      var tpunid = this.filTipoUnida
      var unid = this.filUnidades
      var tipoforn = this.filTipoForn
      var mesRefe = this.filMesRefer
      var anoRefe = this.filAnoRefer

      this.dhtmlx(null, forne, tpunid, unid, tipoforn, mesRefe, anoRefe)
    },
    addTag (newTag) {
        this.filAnoRef.push(newTag)
        this.contasValor()
      }
  },
  mounted: function(){

    if(this.filtro){
      this.dhtmlx();
    }
    else {
      this.$parent.contasVenc()
    }

    api.enviarRequisicao('get', '/api/contas-consumo/tipo-unidades')
      .then(response => {
        for(let i = 0; i < response.data.length; i++){
          this.tipoUnidade.push(response.data[i].tp00_descricao)
        }
        // this.tipoUnidade = response.data
    });
    api.enviarRequisicao('get', '/api/contas-consumo/unidades')
      .then(response => {
        for(let i = 0; i < response.data.length; i++){
          this.unidades.push(response.data[i].ba02_unidade)
        }
        // this.unidades = response.data
    });
    api.enviarRequisicao('get', '/api/contas-consumo/fornecedores')
      .then(response => {
        for(let i = 0; i < response.data.length; i++){
          this.fornecedore.push(response.data[i].ba00_fornecedor)
        }
        // this.fornecedore = response.data
    });
    api.enviarRequisicao('get', '/api/contas-consumo/tipo-fornecimentos')
      .then(response => {
        for(let i = 0; i < response.data.length; i++){
          this.filTipoForneci.push(response.data[i].tp01_descricao)
        }
        // this.filTipoForneci = response.data
    });

    let i = 2000
    let mes = 1

    while(new Date().getFullYear() >= i)
    {
      this.anosCombo.push(i)
      i++
    }
    this.optionsAno = this.anosCombo.slice().reverse()

    while(mes <= 12){
      this.optionsMes.push(mes)
      mes++
    }
  }
}

</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>

<style scoped>

a {
  background-color: #18A689;
  color: #fff;
  font-size: 12px;
  text-decoration: none;
}

.tipoforne {
  height: 100px;
  overflow-y: scroll;
  line-height: 0.8;
}
.tipoforne li {
  list-style: none;
}

</style>
